import React from "react";

const Sort = ({
  desc,
  updateParams,
  updateSort,
  sort,
  sortOptions,
  trending,
}) => (
  <div className="filters-section">
    <div className="sort">
      <i
        className={`pe-1 fa-solid ${
          desc ? "fa-arrow-down-wide-short" : "fa-arrow-up-wide-short"
        }`}
        onClick={updateParams({ desc: !desc, page: 1 })}
      />
      <select
        onChange={updateSort}
        value={trending ? "trending" : sort}
        disabled={trending}
      >
        {trending ? <option value="trending">Trending</option> : null}
        {sortOptions.map(({ value, name }) => (
          <option value={value} key={value}>
            {name}
          </option>
        ))}
      </select>
    </div>
  </div>
);

export default Sort;
